import React from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet";

// COMPONENTS
import GeneralHeader from "../../components/Header/pageNav";

const SalesView = () => {
  const subMenus = [
    {
      title: "Directory",
      link: "",
    },
  ];
  return (
    <main
      className="flex-1 relative z-0 overflow-y-auto focus:outline-none"
      tabIndex="0"
    >
      <Helmet>
        <meta charSet="utf-8" />
        <title>Clients | ATG Staff</title>
      </Helmet>
      <GeneralHeader pageTitle={"Clients"} subMenus={subMenus} />
      <Outlet />
    </main>
  );
};

export default SalesView;
